module.exports = __webpack_public_path__ + "img/5.5de207a7.jpg";